import { render, staticRenderFns } from "./ViewSeatForm.vue?vue&type=template&id=4bc9bf58&scoped=true&"
import script from "./ViewSeatForm.vue?vue&type=script&lang=js&"
export * from "./ViewSeatForm.vue?vue&type=script&lang=js&"
import style0 from "./ViewSeatForm.vue?vue&type=style&index=0&id=4bc9bf58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc9bf58",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bc9bf58')) {
      api.createRecord('4bc9bf58', component.options)
    } else {
      api.reload('4bc9bf58', component.options)
    }
    module.hot.accept("./ViewSeatForm.vue?vue&type=template&id=4bc9bf58&scoped=true&", function () {
      api.rerender('4bc9bf58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chooseSeat/ActivityManage/modules/ViewSeatForm.vue"
export default component.exports